import { Image } from 'antd';

import { DeleteOutlined, DownloadOutlined, PlusOutlined } from '@ant-design/icons';

import { uploadImageApiCall } from '../Api/config';
import { toastError } from '../service/Toast';
import { BASE_IMAGE_URL } from '../env';

const boxStyle: React.CSSProperties = {
  border: '2px dashed #94a3b8',
  borderRadius: '12px',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '220px',
  position: 'relative',
  gap: '12px',
  backgroundColor: '#fafbfc',
};

const boxWithImageStyle: React.CSSProperties = {
  border: 'none',
  borderRadius: '12px',
  padding: '0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  gap: '12px',
  backgroundColor: 'transparent',
};

const headingStyle: React.CSSProperties = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#0f172a',
  marginBottom: '4px',
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
};

const plusStyle: React.CSSProperties = {
  fontSize: '28px',
  color: '#94a3b8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const uploadTextStyle: React.CSSProperties = {
  fontSize: '13px',
  color: '#64748b',
  marginTop: '4px',
};

const imageWrapperStyle: React.CSSProperties = {
  width: '100%',
  height: '200px',
  overflow: 'hidden',
  borderRadius: '8px',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#e2e8f0',
};

const iconBtnStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: '6px',
  right: '6px',
  backgroundColor: '#00000070',
  padding: '4px',
  borderRadius: '4px',
  color: 'white',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

const ImageDragDropContainer = (props: any) => {
  const { photoType, photoDetails, setPhotoDetails, activeItem, fallbackImage } = props;

  const handleChange = async (e: any) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);

    try {
      const res: any = await uploadImageApiCall(`/photo-orders/upload`, formData);
      const { data, isSuccess } = res;
      if (isSuccess) {
        setPhotoDetails(data);
      }
    } catch (err) {
      toastError(
        `Oops, an error occured! creation failed. Please contact development support team`
      );
    }
  };

  const onDownload = async (fileUrl: any) => {
    if (fileUrl) {
      window.open(fileUrl);
    }
  };

  return (
    <div key={`${activeItem}-${photoType}`} style={photoDetails?.url ? boxWithImageStyle : boxStyle}>
      <div style={headingStyle}>{photoType}</div>
      {photoDetails?.url ? (
        <div style={imageWrapperStyle}>
          <Image
            width={200}
            src={
              photoDetails?.url?.startsWith('https') || !photoDetails?.url
                ? photoDetails?.url
                : `${BASE_IMAGE_URL}/${photoDetails?.url}`
            }
            fallback={fallbackImage}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
          <div style={{ position: 'absolute', bottom: '6px', right: '6px', display: 'flex', gap: '6px', flexDirection: 'row', zIndex: 1 }}>
            <span
              style={{ ...iconBtnStyle, position: 'relative' }}
              onClick={() => onDownload(photoDetails?.url)}
            >
              <DownloadOutlined />
            </span>
            <span
              style={{ ...iconBtnStyle, position: 'relative' }}
              onClick={() => setPhotoDetails({})}
            >
              <DeleteOutlined />
            </span>
          </div>
        </div>
      ) : (
        <>
          <div style={plusStyle}>
            <PlusOutlined />
          </div>
          <div style={uploadTextStyle}>Upload a file</div>
          <input
            onChange={e => handleChange(e)}
            type="file"
            id={`avatar-${String(activeItem)}-${photoType}`}
            name={`avatar-${photoType}`}
            accept="image/png, image/jpeg"
            style={{ display: 'none' }}
          />
          <label
            htmlFor={`avatar-${String(activeItem)}-${photoType}`}
            style={{
              cursor: 'pointer',
              fontSize: '13px',
              color: '#2563eb',
              textDecoration: 'underline',
            }}
          >
            Click to upload
          </label>
        </>
      )}
    </div>
  );
};

export default ImageDragDropContainer;
